import script from "./MingguanView.vue?vue&type=script&setup=true&lang=js"
export * from "./MingguanView.vue?vue&type=script&setup=true&lang=js"

import "./MingguanView.vue?vue&type=style&index=0&id=73c51a7b&scoped=true&lang=css"

import exportComponent from "/home/runner/work/adaptif-frontend/adaptif-frontend/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-73c51a7b"]])

export default __exports__